import { AnyAction } from 'redux';
import {
  AuthState,
  GET_RM_DETAIL_SUCCESS,
  GET_USER_INFO_SUCCESS,
  LOGOUT_SUCCESS,
  NEW_VERIFY_LOGIN_OTP_SUCCESS,
  SET_CORRELATION_ID,
  VERIFY_LOGIN_OTP_SUCCESS,
} from '../types/auth';
import { GEN_INV_TOKENCOMPANY_SUCCESS, VERIFY_OTP_PAYMENT_SUCCESS } from '../types/onBoarding';
import { PAYMENT_OPEN_FLOW_VALIDATE_OTP_SUCCESS } from '../types/cart';

const initState: Partial<AuthState> = {
  token: null,
  correlationId: null,
  role: null,
  id: null,
};
function authReducer(state = initState, action: AnyAction): Partial<AuthState> {
  switch (action.type) {

    case PAYMENT_OPEN_FLOW_VALIDATE_OTP_SUCCESS: {
      return {
        ...state,
        // token: action.body.login_token,
        token: '',
        role: `${action?.body?.role ?? ""}`.toLowerCase(),
        id: action.body.userId,
        ...("subRole" in (action?.body ?? {}) ? { subRole: `${action?.body?.subRole ?? ""}`.toLowerCase() } : {})
      }
    }

    case VERIFY_OTP_PAYMENT_SUCCESS: {
      return {
        ...state,
        token: action.body.token,
        role: `${action?.body?.role ?? ""}`.toLowerCase(),
        ...("subRole" in (action?.body ?? {}) ? { subRole: `${action?.body?.subRole ?? ""}`.toLowerCase() } : {})
      }
    }

    case GEN_INV_TOKENCOMPANY_SUCCESS: {
      return {
        ...state,
        ...action.body,
        ...("role" in (action?.body ?? {}) ? { role: `${action?.body?.role ?? ""}`.toLowerCase() } : {}),
        ...("subRole" in (action?.body ?? {}) ? { subRole: `${action?.body?.subRole ?? ""}`.toLowerCase() } : {})
      }
    }
    case VERIFY_LOGIN_OTP_SUCCESS:
    case GET_USER_INFO_SUCCESS: {
      return {
        ...state,
        ...action.body,
        ...("role" in (action?.body ?? {}) ? { role: `${action?.body?.role ?? ""}`.toLowerCase() } : {}),
        ...("subRole" in (action?.body ?? {}) ? { subRole: `${action?.body?.subRole ?? ""}`.toLowerCase() } : {})
      };
    }
    case GET_RM_DETAIL_SUCCESS: {
      return {
        ...state,
        userDetails: {
          ...action.body,
          ...("role" in (action?.body ?? {}) ? { role: `${action?.body?.role ?? ""}`.toLowerCase() } : {}),
          ...("subRole" in (action?.body ?? {}) ? { subRole: `${action?.body?.subRole ?? ""}`.toLowerCase() } : {})
        },
      };
    }
    case SET_CORRELATION_ID: {
      return {
        ...state,
        correlationId: action.correlationId,
      };
    }
    case LOGOUT_SUCCESS: {
      return { ...initState };
    }
    // case NEW_VERIFY_LOGIN_OTP_SUCCESS: {
    //   return {
    //     ...state,
    //     token: action.body.token,
    //   };
    // }
    default:
      return state;
  }
}

export default authReducer;
